import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const VaGridList = () => {
  return (
    <MicroFrontEnd
      name="VaGridList"
      src={apiConfig.microFrontEnds.VaGridList}
    />
  )
}

export default VaGridList
